import React from "react";
import { translate } from "../../utils/translations/translate";
import Input from "../UI/Input";
import { StyledCardSection } from "./styles";
const ProjectVendor = ({ formik, isReadOnlyMode }) => {
  const {
    vendorName,
    vendorAddress,
    timesheetTo,
    invoiceTo,
    msaSignatoryTitle,
    msaSignatoryName,
    msaSignatoryEmail,
    msaSignatoryPhone,
    recruiterName,
    recruiterEmail,
    recruiterPhone,
    recruiterTitle,
    accountingContactName,
    accountingContactEmail,
    accountingContactPhone,
    accountingContactTitle,
    escalationContactName,
    escalationContactEmail,
    escalationContactPhone,
    escalationContactTitle,
  } = formik.values;

  return (
    <StyledCardSection>
      <h1 className="tma_section-title">{translate("labels.primeVendor")}</h1>
      <div className="tma-form_field_content two">
        <div className="tma_form-control">
          <Input
            id={"vendorName"}
            name="vendorName"
            labelText={translate("labels.vendorName")}
            value={vendorName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            inputProps={{ maxLength: 100 }}
            error={
              formik.touched.vendorName &&
              Boolean(formik.errors.vendorName)
            }
            helperText={
              formik.touched.vendorName && formik.errors.vendorName
            }
            disabled={isReadOnlyMode}
          />
        </div>
        <div className="tma_form-control tma_align_label">
          <Input
            id="vendorAddress"
            name="vendorAddress"
            showInfoToolTip={false}
            labelText={translate("labels.vendorAddress")}
            value={vendorAddress}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            inputProps={{ maxLength: 255 }}
            error={
              formik.touched.vendorAddress &&
              Boolean(formik.errors.vendorAddress)
            }
            helperText={
              formik.touched.vendorAddress && formik.errors.vendorAddress
            }
            disabled={isReadOnlyMode}
          />
        </div>
      </div>
      <div className="tma-form_field_content two">
        <div className="tma_form-control tma_align_label">
          <Input
            id="timesheetTo"
            name="timesheetTo"
            showInfoToolTip={false}
            labelText={translate("labels.timesheetTo")}
            type="email"
            value={timesheetTo}
            onChange={formik.handleChange}
            inputProps={{ maxLength: 100 }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.timesheetTo &&
              Boolean(formik.errors.timesheetTo)
            }
            helperText={
              formik.touched.timesheetTo && formik.errors.timesheetTo
            }
            disabled={isReadOnlyMode}
          />
        </div>
        <div className="tma_form-control">
          <Input
            id="invoiceTo"
            name="invoiceTo"
            showInfoToolTip={false}
            labelText={translate("labels.invoiceTo")}
            type="email"
            value={invoiceTo}
            inputProps={{ maxLength: 100 }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.invoiceTo &&
              Boolean(formik.errors.invoiceTo)
            }
            helperText={
              formik.touched.invoiceTo && formik.errors.invoiceTo
            }
            disabled={isReadOnlyMode}
          />
        </div>
      </div>
      <div className="form_card">
        <h1 className="tma_section-subtitle">{translate("labels.msaInfo")}</h1>
        <div className="tma-form_field_content no-padding">
          <div className="tma_form-control tma_align_label">
            <Input
              id="msaSignatoryName"
              name="msaSignatoryName"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.msaSignator")}
              value={msaSignatoryName}
              inputProps={{ maxLength: 100 }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.msaSignatoryName &&
                Boolean(formik.errors.msaSignatoryName)
              }
              helperText={
                formik.touched.msaSignatoryName && formik.errors.msaSignatoryName
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
        <div className="tma-form_field_content">
          <div className="tma_form-control tma_min_input">
            <Input
              id="msaSignatoryTitle"
              name="msaSignatoryTitle"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.title")}
              value={msaSignatoryTitle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.msaSignatoryTitle &&
                Boolean(formik.errors.msaSignatoryTitle)
              }
              helperText={
                formik.touched.msaSignatoryTitle && formik.errors.msaSignatoryTitle
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="msaSignatoryEmail"
              name="msaSignatoryEmail"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.email")}
              value={msaSignatoryEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.msaSignatoryEmail &&
                Boolean(formik.errors.msaSignatoryEmail)
              }
              helperText={
                formik.touched.msaSignatoryEmail && formik.errors.msaSignatoryEmail
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="msaSignatoryPhone"
              name="msaSignatoryPhone"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.phone")}
              value={msaSignatoryPhone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 15 }}
              error={
                formik.touched.msaSignatoryPhone &&
                Boolean(formik.errors.msaSignatoryPhone)
              }
              helperText={
                formik.touched.msaSignatoryPhone && formik.errors.msaSignatoryPhone
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
      </div>
      <div className="form_card">
        <h1 className="tma_section-subtitle">{translate("labels.recruiterInfo")}</h1>
        <div className="tma-form_field_content no-padding">
          <div className="tma_form-control tma_align_label">
            <Input
              id="recruiterName"
              name="recruiterName"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.recruiterName")}
              value={recruiterName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.recruiterName &&
                Boolean(formik.errors.recruiterName)
              }
              helperText={
                formik.touched.recruiterName && formik.errors.recruiterName
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
        <div className="tma-form_field_content">
          <div className="tma_form-control tma_min_input">
            <Input
              id="recruiterTitle"
              name="recruiterTitle"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.title")}
              value={recruiterTitle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.recruiterTitle &&
                Boolean(formik.errors.recruiterTitle)
              }
              helperText={
                formik.touched.recruiterTitle && formik.errors.recruiterTitle
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="recruiterEmail"
              name="recruiterEmail"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.email")}
              value={recruiterEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.recruiterEmail &&
                Boolean(formik.errors.recruiterEmail)
              }
              helperText={
                formik.touched.recruiterEmail && formik.errors.recruiterEmail
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="recruiterPhone"
              name="recruiterPhone"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.phone")}
              value={recruiterPhone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 15 }}
              error={
                formik.touched.recruiterPhone &&
                Boolean(formik.errors.recruiterPhone)
              }
              helperText={
                formik.touched.recruiterPhone && formik.errors.recruiterPhone
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
      </div>
      <div className="form_card">
        <h1 className="tma_section-subtitle">{translate("labels.accountingInfo")}</h1>
        <div className="tma-form_field_content no-padding">
          <div className="tma_form-control tma_align_label">
            <Input
              id="accountingContactName"
              name="accountingContactName"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.accountingContact")}
              value={accountingContactName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.accountingContactName &&
                Boolean(formik.errors.accountingContactName)
              }
              helperText={
                formik.touched.accountingContactName && formik.errors.accountingContactName
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
        <div className="tma-form_field_content">
          <div className="tma_form-control tma_min_input">
            <Input
              id="accountingContactTitle"
              name="accountingContactTitle"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.title")}
              value={accountingContactTitle}
              onChange={formik.handleChange}
              inputProps={{ maxLength: 100 }}
              onBlur={formik.handleBlur}
              error={
                formik.touched.accountingContactTitle &&
                Boolean(formik.errors.accountingContactTitle)
              }
              helperText={
                formik.touched.accountingContactTitle && formik.errors.accountingContactTitle
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="accountingContactEmail"
              name="accountingContactEmail"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.email")}
              value={accountingContactEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.accountingContactEmail &&
                Boolean(formik.errors.accountingContactEmail)
              }
              helperText={
                formik.touched.accountingContactEmail && formik.errors.accountingContactEmail
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="accountingContactPhone"
              name="accountingContactPhone"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.phone")}
              value={accountingContactPhone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 15 }}
              error={
                formik.touched.accountingContactPhone &&
                Boolean(formik.errors.accountingContactPhone)
              }
              helperText={
                formik.touched.accountingContactPhone && formik.errors.accountingContactPhone
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
      </div>
      <div className="form_card">
        <h1 className="tma_section-subtitle">{translate("labels.escalationInfo")}</h1>
        <div className="tma-form_field_content no-padding">
          <div className="tma_form-control tma_align_label">
            <Input
              id="escalationContactName"
              name="escalationContactName"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.escalationContact")}
              value={escalationContactName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.escalationContactName &&
                Boolean(formik.errors.escalationContactName)
              }
              helperText={
                formik.touched.escalationContactName && formik.errors.escalationContactName
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
        <div className="tma-form_field_content">
          <div className="tma_form-control tma_min_input">
            <Input
              id="escalationContactTitle"
              name="escalationContactTitle"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.title")}
              value={escalationContactTitle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.escalationContactTitle &&
                Boolean(formik.errors.escalationContactTitle)
              }
              helperText={
                formik.touched.escalationContactTitle && formik.errors.escalationContactTitle
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="escalationContactEmail"
              name="escalationContactEmail"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.email")}
              value={escalationContactEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.escalationContactEmail &&
                Boolean(formik.errors.escalationContactEmail)
              }
              helperText={
                formik.touched.escalationContactEmail && formik.errors.escalationContactEmail
              }
              disabled={isReadOnlyMode}
            />
          </div>
          <div className="tma_form-control tma_min_input">
            <Input
              id="escalationContactPhone"
              name="escalationContactPhone"
              showInfoToolTip={false}
              placeholderLabelText={translate("labels.phone")}
              value={escalationContactPhone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 15 }}
              error={
                formik.touched.escalationContactPhone &&
                Boolean(formik.errors.escalationContactPhone)
              }
              helperText={
                formik.touched.escalationContactPhone && formik.errors.escalationContactPhone
              }
              disabled={isReadOnlyMode}
            />
          </div>
        </div>
      </div>
    </StyledCardSection>
  );
};

export default ProjectVendor;
